export const isPureNumber = (value: string) => /^\d+$/.test(value);
export const onlyDigits = (s: string) => s.replace(/\D/g, '');

export const formatThousands = (digits: string) => digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const normalizeNumberData = (
  array: number[] = [],
  options: { formatThousands?: boolean } = {}
) => {
  const { formatThousands: shouldFormat = false } = options;

  return array.map(item => ({
    id: item,
    name: shouldFormat ? formatThousands(String(item)) : String(item)
  }));
};

export const getCatalogKey = (field: string, catalogDataMap: Record<string, string>): string =>
  catalogDataMap?.[field] || field;

export const convertFlatNumericStrings = (obj: Record<string, unknown>): Record<string, unknown> =>
  Object.entries(obj).reduce(
    (result, [key, value]) => {
      if (typeof value === 'string') {
        const stripped = value.trim().replace(/\s/g, '');
        result[key] = stripped !== '' && isPureNumber(stripped) ? Number(stripped) : value;
      } else {
        result[key] = value;
      }
      return result;
    },
    {} as Record<string, unknown>
  );

export const numberWithSpaces = (number: number) => {
  if (Number.isNaN(number)) return '';

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
